import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

const rise = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: 0.08 * i, ease: [0.2, 0.7, 0.2, 1] },
  }),
};

export default function HowItWorks() {
  const { t } = useI18n();
  const steps = t("how.steps");
  return (
    <section id="how" className="section-dark py-24 md:py-32 relative overflow-hidden" data-testid="section-how">
      <div className="grain absolute inset-0" />
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="eyebrow text-[#FAF9F6]/60">{t("how.eyebrow")}</div>
            <h2 className="mt-4 font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight">
              {t("how.title")}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-[#FAF9F6]/75 leading-relaxed text-lg self-end">
            {t("how.lead")}
          </div>
        </div>

        {/* Bento */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-5 auto-rows-[200px] md:auto-rows-[240px]">
          {Array.isArray(steps) &&
            steps.map((s, i) => (
              <motion.article
                key={i}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                variants={rise}
                className={[
                  "relative border border-white/12 rounded-md p-6 md:p-7 flex flex-col justify-between overflow-hidden bg-white/[0.02]",
                  i === 0 ? "md:col-span-3" : "",
                  i === 1 ? "md:col-span-3" : "",
                  i === 2 ? "md:col-span-2" : "",
                  i === 3 ? "md:col-span-4" : "",
                ].join(" ")}
                data-testid={`how-step-${i}`}
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono-mark text-xs tracking-[0.3em] text-[#D97706]">
                    {s.num}
                  </span>
                  <span className="font-mono-mark text-[0.65rem] tracking-[0.3em] uppercase text-[#FAF9F6]/40">
                    step
                  </span>
                </div>
                <div>
                  <h3 className="font-serif-display text-2xl md:text-3xl leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[#FAF9F6]/65 text-sm md:text-base leading-relaxed max-w-md">
                    {s.desc}
                  </p>
                </div>
                <div className="absolute -right-8 -bottom-10 w-40 h-40 rounded-full bg-[#D97706]/10 blur-2xl pointer-events-none" />
              </motion.article>
            ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-14 max-w-3xl text-[#FAF9F6]/70 leading-relaxed"
        >
          {t("how.closing")}
        </motion.p>
      </div>
    </section>
  );
}
